import script from "./AiRootPractice.vue?vue&type=script&setup=true&lang=js"
export * from "./AiRootPractice.vue?vue&type=script&setup=true&lang=js"

import "./AiRootPractice.vue?vue&type=style&index=0&id=7c3e5895&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3e5895"]])

export default __exports__